import { useState, useEffect, useRef } from 'react';
import styles from './index.module.scss';
import {
  Menu,
  Input,
  Popover,
  Tag,
  Modal,
  Upload,
  Table,
  Checkbox,
  message,
  Form,
  Row,
  Col,
  List,
} from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { fetchIndustrialDictionary } from '@/service/sys';
import {
  ZoomOutOutlined,
  CaretDownOutlined,
  UserOutlined,
  CloseOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import logoImg from '../../assets/image/logo.png';
import hotImg from '../../assets/image/组 52.png';
import type { MenuProps } from 'antd';
import { useSnapshotRoot } from '@/stores/root';
import { useSnapshotCart } from '@/stores/cart';
import { ICurrentUser } from '@/service/user/types';
import { fetchProductList, fetchProductCategories, fetchAddProducts } from '@/service/product';
import cart from '../../assets/image/cart.png';
import quickorder from '../../assets/image/quickorder.png';
import search from '../../assets/image/search.png';
import Button from '@/components/button';
import { queryProductTotalStock } from '@/service/product';
import { fetchQueryDocumentClassifyList } from '@/service/information';
import { getOperatorCustomer } from '@/service/order';
import { exportQuotation, quickTemplate, SDIXlsx, batchProductToCart } from '@/service/cart/index';
import { pageNameStore, useSnapshotPageName } from '@/stores/pageName';
function findItem(items: any, key: number | string, currents: any = [], level = 1) {
  //根据key逐级查找所有父元素
  for (let i = 0, len = items.length; i < len; i++) {
    if (items[i].key === key) {
      return [[...currents, items[i]], level];
    }
    if (items[i].children && items[i].children.length > 0) {
      const [result, ins]: any = findItem(
        items[i].children,
        key,
        [...currents, items[i]],
        level + 1
      );
      if (result) {
        return [result, ins];
      }
    }
  }
  return [];
}

const resultFormat = result => {
  result = result.map((item: any, index: number) => {
    const data = mallLCategoriesObj[index];
    if (data) {
      return Object.assign({}, { key: item.key, level: data });
    }
    //return null
  });
  return result;
};

const Userhook = ({
  options,
  onChange,
  current,
  onRegister,
  onLoginClick, // 新增一个点击登录的回调函数
}: {
  current?: ICurrentUser;
  options: any;
  onChange: any;
  onRegister: any;
  onLoginClick: any; // 新增一个点击登录的回调函数
}) => {
  const navigate = useNavigate();
  const { getPageName } = useSnapshotPageName();
  return (
    <div className={styles.userHookRegister}>
      |
      {current?.userName ? (
        <div className={styles.userHook}>
          <UserOutlined
            className={styles.icon_left}
            onClick={() => {
              gio('track', "OW_topNavigationBarClick", {
                "trafficName_var" : `账户信息`,
                "firstpositionName_var" : `-`,
                "secondpositionName_var" : `-`,
                "thirdpositionName_var": `-`,
                "fourPositionName_var": `-`,
                "pageName_var": `${getPageName()}`,
              });
              navigate('/personal-center/user-info');
            }}
          />
          <div>您好，{current.userName}</div>
          <CaretDownOutlined className={styles.icon_right} />
          <div className={styles.options}>
            {options.map((item: any) => {
              return item.render ? (
                <item.render
                  key={JSON.stringify(item)}
                  onClick={() => {
                    onChange(item);
                  }}
                  className={styles.item}
                />
              ) : (
                <div
                  key={JSON.stringify(item)}
                  className={styles.item}
                  onClick={() => {
                    onChange(item);
                  }}>
                  {item.label}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className={styles.userHookRegister}>
          <div className={styles.login_in} onClick={onLoginClick}>
            登录
          </div>
          <div className={styles.registerDiv}>
            <div className={styles.register} onClick={onRegister}>
              注册
            </div>
          </div>
        </div>
      )}
      {/* 您好，{current?.nameZh} */}
    </div>
  );
};


const mallLCategoriesObj: any = {
  1: 'mallL1Categories',
  2: 'mallL2Categories',
  3: 'mallL3Categories',
  4: 'mallL4Categories',
  5: 'mallL5Categories',
};

const Navigation = (props): any => {
  const { setProduct } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const [current, setCurrent] = useState('mail');
  const [keyWord, setKeyWord] = useState<any>('');
  const { refresh: fetchCurrent, current: currentUser } = useSnapshotRoot();
  const { refresh: fetchCart } = useSnapshotCart();
  const [isPopover, setIsPopover] = useState(false);
  const [isSDI, setIsSDI] = useState(false);
  const [isLoadings, setIsLoadings] = useState<boolean>(true);
  const [isquickImportModal, setIsquickImportModal] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [list, setList] = useState([]);
  const [selectedRowKeysManua, setSelectedRowKeysManua] = useState<string[]>([]);

  const [form] = Form.useForm();
  const [cacheDatas, setCacheDatas] = useState({});
  const [isFetchingCaches, setIsFetchingCaches] = useState(false);
  const [checkvelue, setCheckvelue] = useState(false); // searchCustomerPrice
  const [productsData, setProductsData] = useState([]); // 手动下单列表
  const [manualAdditionSDIModal, setManualAdditionSDIModal] = useState(false); // 快速导入弹窗手动添加弹窗
  const [loading, setLoading] = useState(false);
  const { refresh } = useSnapshotCart();
  const [params, setParams] = useState({
    pageNum: 1,
    pageSize: 10,
    searchCustomerPrice: false,
  })
  const [isSDISearch, setIsSDISearch] = useState(false);
  const [searchList, setSearchList] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const { pageName, setPageName, getPageName, setPrePageName, searchType,
     setSearchType, setSearchRegion, getProductInformation, getIndustrialCases,
     getIndustryDic, getProductClass, isSearch, setIsSearch } = useSnapshotPageName();

  // 根据路由设置菜单选中状态
  useEffect(() => {
    const pathname = location.pathname;
    if (pathname === '/developer-guide') {
      setCurrent('88888');
    } else if (pathname === '/product-information') {
      setCurrent('444444');
    } else if (pathname === '/industry-cases') {
      setCurrent('77777');
    } else if (pathname === '/industrial-dictionary') {
      setCurrent('66');
    } else if (pathname && pathname.startsWith('/selection-service')) {
      setCurrent('22');
    } else if (pathname && pathname.startsWith('/productList')) {
      setCurrent('11');
    } else {
      setCurrent('mail');
    }
  }, [location.pathname]);

     const defaultItems = [
      {
        label: <div className={styles.menuItems} onClick={() => {
          gio('track', "OW_topNavigationBarClick", {
            "trafficName_var" : `产品分类`,
            "firstpositionName_var" : `-`,
            "secondpositionName_var" : `-`,
            "thirdpositionName_var": `-`,
            "fourPositionName_var": `-`,
            "pageName_var": `${getPageName()}`,
          });
        }}>产品分类</div>,
        labeltext: '产品分类',
        key: '11',
        children: [],
      },
      {
        label: <div className={styles.menuItems} onClick={() => {
          gio('track', "OW_topNavigationBarClick", {
            "trafficName_var" : `选型服务`,
            "firstpositionName_var" : `-`,
            "secondpositionName_var" : `-`,
            "thirdpositionName_var": `-`,
            "fourPositionName_var": `-`,
            "pageName_var": `${getPageName()}`,
          });
        }}>选型服务</div>,
        labeltext: '选型服务',
        key: '22',
        children: [],
      },
      {
        label: (
          <a className={styles.menuItems} href="/product-information" onClick={() => {
            gio('track', "OW_topNavigationBarClick", {
              "trafficName_var" : `产品资料`,
              "firstpositionName_var" : `-`,
              "secondpositionName_var" : `-`,
              "thirdpositionName_var": `-`,
              "fourPositionName_var": `-`,
              "pageName_var": `${getPageName()}`,
            });
          }}>
            产品资料
          </a>
        ),
        key: '444444',
        labeltext: '产品资料',
        children: [],
      },
      // {
      //   label: (
      //     <a className={styles.menuItems} href="/personal-center/upload-inquiry">
      //       在线询价
      //     </a>
      //   ),
      //   key: '555555',
      //   labeltext: '在线询价',
      //   children: [],
      // },
      {
        label: <div className={styles.menuItems} onClick={() => {
          gio('track', "OW_topNavigationBarClick", {
            "trafficName_var" : `工业字典`,
            "firstpositionName_var" : `-`,
            "secondpositionName_var" : `-`,
            "thirdpositionName_var": `-`,
            "fourPositionName_var": `-`,
            "pageName_var": `${getPageName()}`,
          });
        }}>工业字典</div>,
        labeltext: '工业字典',
        key: '66',
        children: [],
      },
      {
        label: (
          <a className={styles.menuItems} href="/industry-cases" onClick={() => {
            gio('track', "OW_topNavigationBarClick", {
              "trafficName_var" : `行业案例`,
              "firstpositionName_var" : `-`,
              "secondpositionName_var" : `-`,
              "thirdpositionName_var": `-`,
              "fourPositionName_var": `-`,
              "pageName_var": `${getPageName()}`,
            });
          }}>
            行业案例
          </a>
        ),
        labeltext: '行业案例',
        key: '77777',
        children: [],
      },
      {
        label: (
          <a className={styles.menuItems} href="/developer-guide" onClick={() => {
            gio('track', "OW_topNavigationBarClick", {
              "trafficName_var" : `对接指南`,
              "firstpositionName_var" : `-`,
              "secondpositionName_var" : `-`,
              "thirdpositionName_var": `-`,
              "fourPositionName_var": `-`,
              "pageName_var": `${getPageName()}`,
            });
          }}>
            对接指南
          </a>
        ),
        labeltext: '对接指南',
        key: '88888',
        children: [],
      },
      // {
      //   label: <div className={styles.menuItems}>照明专区</div>,
      //   labeltext: '照明专区',
      //   key: '000',
      //   children: [],
      // },
    ];
  const [items, setItems] = useState(defaultItems);
  // 手动添加弹窗
  const columnsList = [
    {
      title: '物料号',
      dataIndex: 'ifsSku',
    },
    {
      title: '零件号',
      dataIndex: 'customerSku',
    },
    {
      title: '产品名称',
      dataIndex: 'productName',
    },
    // {
    //   title: '分类',
    //   dataIndex: 'ifsSku',
    // },
    {
      title: '面价',
      dataIndex: 'marketPrice',
    },

    {
      title: '折扣价',
      dataIndex: 'taxDiscountPrice',
    },
    {
      title: '未税折扣价',
      dataIndex: 'discountPrice',
    },
    {
      title: '可用库存',
      dataIndex: 'stock',
    },
  ];
  const newItems = useRef(null);

  useEffect(() => {
    newItems.current = [...items];
  }, [items]);
  const getIsSDI = () => {
    if (currentUser) {
      getOperatorCustomer().then(res => {
        if (res.ediSwitch === 1) {
          setIsSDI(true);
          sessionStorage.setItem('sdi', `true`);
        } else {
          sessionStorage.setItem('sdi', `false`);
        }
      });
    }
  };

  const handlerItems = (data: any) => {
    return data.map((item: any) => {
      return {
        label: (
          <div
            className={styles.menuItems}
            onClick={() => {
              setCurrent(item.categoriesCode);
              const [result, level] = findItem(newItems.current, item.categoriesCode);
              const obj = resultFormat(result).map((item: any, index: number) =>
                item ? { [item.level]: item.key } : null
              );
              const pageNames = result.map((item: any, index: number) => {
                return item ? item.labeltext : null;
              })
              const newObj = Object.assign({}, ...obj);
              const paramsData = {
                mallL1Categories: '',
                mallL2Categories: '',
                mallL3Categories: '',
                mallL4Categories: '',
                mallL5Categories: '',
                keyWord: '',
                pageNo: 1,
                pageSize: 20,
                brandIds:[],
                sustainableOfferQualification: '',
                hasStock: null,
                attributes:[],
                ...newObj,
              }
              console.log(pageNames);
              let pageName_var = '';
              for(let i = 0; i < pageNames.length; i++) {
                pageName_var += pageNames[i];
                pageName_var += '-';
              }
              pageName_var += '产品列表页';
              setPrePageName(getPageName());
              console.log(getPageName());
              gio('track', "OW_topNavigationBarClick", {
                "trafficName_var" : `产品分类`,
                "firstpositionName_var" : `${pageNames.length >= 2 ? pageNames[1] : '-'}`,
                "secondpositionName_var" : `${pageNames.length >= 3 ? pageNames[2] : '-'}`,
                "thirdpositionName_var": `${pageNames.length >= 4 ? pageNames[3] : '-'}`,
                "fourPositionName_var": `${pageNames.length >= 5 ? pageNames[4] : '-'}`,
                "pageName_var": `${getPageName()}`,
              });
              // setPageName(pageName_var);
              navigate(`/productList?data=${JSON.stringify(paramsData)}`);
              window.location.reload();
            }}>
            {item.categoriesName}
          </div>
        ),
        labeltext: item.categoriesName,
        key: item.categoriesCode,
        children:
          item.children && item.children.length > 0 ? handlerItems(item.children) : undefined,
      };
    });
  };
  useEffect(() => {
    if (manualAdditionSDIModal === true) {
      queryAddProducts(params)
    }
  }, [params, manualAdditionSDIModal])
  // 手动添加搜索
  const queryAddProducts = formData => {
    setLoading(true);
    fetchAddProducts({ pageNum: 1, pageSize: 10, ...formData }).then(res => {
      let params = res.list.map(item => {
        return item.ifsSku;
      });
      setProductsData(res);
      if(isSDISearch){
        gio('track', "OW_searchSuccess", {
          "searchType_var" : `关键词搜索`,
          "keyWord_var" : `${formData.name === undefined ? '-' : formData.name}`,
          "partNumber_var": `${formData.skuCode === undefined ? '-' : formData.skuCode}`,
          "MaterialNumber_var": `${formData.ifsSku === undefined ? '-' : formData.ifsSku}`,
          "searchIsResult_var" : `${res.total > 0 ? '是' : '否'}`,
          "parPageName_var": `${getPageName()}`,
          "area_var": `SDI快速下单`,
          "searchResultCount_var": res.total || 0,
        });
      }
      if(params?.length > 0){
        queryProductTotalStock(params).then(obj => {
          setProductsData({
            ...res,
            list: res.list.map(item => {
              return {
                ...item,
                stock: obj[item.ifsSku] || 0,
              };
            }),
          });
          columnsList[0].dataIndex = 'stock';
        });
      }
    }).finally(() => {
      setLoading(false);
      setIsSDISearch(false);
    });;
  };
  const sdiOnCancel = () => {
    form.resetFields()
    setParams({
      pageNum: 1,
      pageSize: 10,
      searchCustomerPrice: false,
    })
    setManualAdditionSDIModal(false)
  }
  // 点击完成
  const addProductCart = () => {
    const selectedSkuCodes = selectedRowKeysManua.map(
      key => productsData.list.find(item => item.id === key).skuCode
    );
    const parma = selectedSkuCodes.map(skuCode => ({
      skuCode,
      newItem: true,
      qty: 1,
      checked: true,
    }));
    batchProductToCart(parma).then(res => {
      message.success('添加购物车成功');
      setManualAdditionSDIModal(false);
      setIsquickImportModal(false);
    });
  };

  // 工业字典
  const handlerIndustrialDictionary = (data: any, id: string, firstId: string) => {
    return data.map((item: any) => {
      return {
        label: (
          <div
            className={styles.menuItems}
            onClick={() => {
              setCurrent(item.id);
              const industryDic = getIndustryDic(item.id);
              gio('track', "OW_topNavigationBarClick", {
                "trafficName_var" : `工业字典`,
                "firstpositionName_var" : `${industryDic.length > 0 ? industryDic[0] : '-'}`,
                "secondpositionName_var" : `${industryDic.length > 1 ? industryDic[1] : '-'}`,
                "thirdpositionName_var": `-`,
                "fourPositionName_var": `-`,
                "pageName_var": `${getPageName()}`,
              })
              if (id === 'firstId') {
                navigate(`/industrial-dictionary/one?${id}=${item?.id}&&title=${item?.title}`);
              } else {
                navigate(
                  `/industrial-dictionary/one?firstId=${firstId}&&secondId=${item?.id}&&title=${item?.title}`
                );
              }
            }}>
            {item.title}
          </div>
        ),
        labeltext: item.title,
        key: item.id,
        children:
          item.subCategoryList && item.subCategoryList.length > 0
            ? handlerIndustrialDictionary(item.subCategoryList, 'secondId', item.id)
            : undefined,
      };
    });
  };

  // 产品分类接口
  const queryCategoryList = async () => {
    const res = await fetchProductCategories();
    sessionStorage.setItem('productClass', JSON.stringify({ res: res }));
    setItems(arr =>
      arr.map((item, index) => {
        return index === 0
          ? {
              ...item,
              children: handlerItems(res),
            }
          : item;
      })
    );
    setProduct(res);
  };
  // 工业字典接口 handlerIndustrialDictionary
  const queryIndustrialDictionary = async () => {
    const res = await fetchIndustrialDictionary();
    sessionStorage.setItem('industrialDictionary', JSON.stringify({ res: res }));
    setItems(arr =>
      arr.map((item, index) => {
        return index === 3
          ? {
              ...item,
              children: handlerIndustrialDictionary(res, 'firstId', '111'),
            }
          : item;
      })
    );
  };
  const handlerProductInfo = list => {
    return list.map((item: any) => {
      return {
        label: (
          <div
            className={styles.menuItems}
            onClick={() => {
              const productInfos = getProductInformation(item.id);
                gio('track', "OW_topNavigationBarClick", {
                  "trafficName_var" : `产品资料`,
                  "firstpositionName_var" : `${productInfos.length > 0 ? productInfos[0] : '-'}`,
                  "secondpositionName_var" : `${productInfos.length > 1 ? productInfos[1] : '-'}`,
                  "thirdpositionName_var": `-`,
                  "fourPositionName_var": `-`,
                  "pageName_var": `${getPageName()}`,
                });
              setCurrent(item.id);
              navigate(`/product-information/menu/list?classifyId=${item.id}`);
            }}>
            {item.title}
          </div>
        ),
        labeltext: item.title,
        key: item.id,
        children: item.child && item.child.length > 0 ? handlerProductInfo(item.child) : undefined,
      };
    });
  };

  const queryProductInfo = async () => {
    const res = await fetchQueryDocumentClassifyList({ classifyTitle: '产品资料导航' });
    sessionStorage.setItem('ProductInfo', JSON.stringify({ res: res }));
    setItems(arr =>
      arr.map((item: any, index: number) => {
        return index === 2
          ? {
              ...item,
              children: handlerProductInfo(res),
            }
          : item;
      })
    );
  };

  const handlerIndustryCases = list => {
    return list.map((item: any) => {
      return {
        label: (
          <div
            className={styles.menuItems}
            onClick={() => {
              setCurrent(item.id);
              const industryCases = getIndustrialCases(item.id);
              gio('track', "OW_topNavigationBarClick", {
                "trafficName_var" : `行业案例`,
                "firstpositionName_var" : `${industryCases.length > 0 ? industryCases[0] : '-'}`,
                "secondpositionName_var" : `${industryCases.length > 1 ? industryCases[1] : '-'}`,
                "thirdpositionName_var": `${industryCases.length > 2 ? industryCases[2] : '-'}`,
                "fourPositionName_var": `${industryCases.length > 3 ? industryCases[3] : '-'}`,
                "pageName_var": `${getPageName()}`,
              })
              navigate(`/industry-cases/menu/list?classifyId=${item.id}`);
            }}>
            {item.title}
          </div>
        ),
        labeltext: item.title,
        key: item.id,
        children:
          item.child && item.child.length > 0 ? handlerIndustryCases(item.child) : undefined,
      };
    });
  };
  const querySelectionService = () => {
    setItems(arr =>
      arr.map((item: any, index: number) => {
        return index === 1
          ? {
              ...item,
              children: handlerSelectionService(),
            }
          : item;
      })
    );
  };
  const handlerSelectionService = () => {
    return [
      {
        label: (
          <div
            className={styles.menuItems}
            onClick={() => {
              gio('track', "OW_topNavigationBarClick", {
                "trafficName_var" : `选型服务`,
                "firstpositionName_var" : `张工选型`,
                "secondpositionName_var" : `-`,
                "thirdpositionName_var": `-`,
                "fourPositionName_var": `-`,
                "pageName_var": `${getPageName()}`,
              });
              navigate(`/selection-service/zhanggong`);
            }}>
            张工选型
          </div>
        ),
        labeltext: '张工选型',
        key: 1,
        children: [],
      },
      {
        label: (
          <div
            className={styles.menuItems}
            onClick={() => {
              gio('track', "OW_topNavigationBarClick", {
                "trafficName_var" : `选型服务`,
                "firstpositionName_var" : `西门子TIA选型`,
                "secondpositionName_var" : `-`,
                "thirdpositionName_var": `-`,
                "fourPositionName_var": `-`,
                "pageName_var": `${getPageName()}`,
              });
              navigate(`/selection-service/ximenziTIA`);
            }}>
            西门子TIA选型
          </div>
        ),
        labeltext: '西门子TIA选型',
        key: 2,
        children: [],
      },
      {
        label: (
          <div
            className={styles.menuItems}
            onClick={() => {
              gio('track', "OW_topNavigationBarClick", {
                "trafficName_var" : `选型服务`,
                "firstpositionName_var" : `西门子伺服电机选型`,
                "secondpositionName_var" : `-`,
                "thirdpositionName_var": `-`,
                "fourPositionName_var": `-`,
                "pageName_var": `${getPageName()}`,
              });
              navigate(`/selection-service/ximenzi`);
            }}>
            西门子伺服电机选型
          </div>
        ),
        labeltext: '西门子伺服电机选型',
        key: 3,
        children: [],
      },
    ];
  };
  const queryIndustryCases = async () => {
    const res = await fetchQueryDocumentClassifyList({ classifyTitle: '行业案例导航' });
    sessionStorage.setItem('IndustryCases', JSON.stringify({ res: res }));
    setItems(arr =>
      arr.map((item: any, index: number) => {
        return index === 4
          ? {
              ...item,
              children: handlerIndustryCases(res),
            }
          : item;
      })
    );
  };
  // 点击每一项得操作
  const handlerParticular = e => {
    if (e.value === '111') {
      gio('track', "OW_topNavigationBarClick", {
        "trafficName_var" : `我的信息`,
        "firstpositionName_var" : `-`,
        "secondpositionName_var" : `-`,
        "thirdpositionName_var": `-`,
        "fourPositionName_var": `-`,
        "pageName_var": `${getPageName()}`,
      });
      navigate('/personal-center/user-info?key=user-account');
      window.location.reload();
    }
    if (e.value === '66') {
      sessionStorage.clear();
      localStorage.clear();
      gio('track', "OW_topNavigationBarClick", {
        "trafficName_var" : `登出`,
        "firstpositionName_var" : `-`,
        "secondpositionName_var" : `-`,
        "thirdpositionName_var": `-`,
        "fourPositionName_var": `-`,
        "pageName_var": `${getPageName()}`,
      });
      navigate('/loginIn');
    }
    if (e.value === '33') {
      gio('track', "OW_topNavigationBarClick", {
        "trafficName_var" : `我的订单`,
        "firstpositionName_var" : `-`,
        "secondpositionName_var" : `-`,
        "thirdpositionName_var": `-`,
        "fourPositionName_var": `-`,
        "pageName_var": `${getPageName()}`,
      });
      navigate('/personal-center/order-list?key=transaction-management');
      window.location.reload();
    }
    if (e.value === '22') {
      gio('track', "OW_topNavigationBarClick", {
        "trafficName_var" : `地址管理`,
        "firstpositionName_var" : `-`,
        "secondpositionName_var" : `-`,
        "thirdpositionName_var": `-`,
        "fourPositionName_var": `-`,
        "pageName_var": `${getPageName()}`,
      });
      navigate('/personal-center/user-address?key=user-account');
      window.location.reload();
    }
  };
  // form.setFieldsValue({
  //   searchCustomerPrice: false,
  // });
  const onSearch = () => {
    const formData = form.getFieldsValue();
    // queryAddProducts(formData);
    setIsSDISearch(true);
    setParams((obj) => {
      return {
        ...obj,
        ...formData,
        pageNum: 1,
        pageSize: 10,
      };
    })
  };
  const addToCart = () => {
    const selectedSkuCodes = selectedRowKeysManua.map(
      key => productsData.list.find(item => item.id === key).skuCode
    );
    const parma = selectedSkuCodes.map(skuCode => ({
      skuCode,
      newItem: true,
      qty: 1,
      checked: true,
    }));
    const addProducts = selectedRowKeysManua.map(
      key => productsData.list.find(item => item.id === key)
    );
    addProducts.map((item, index) => {
      console.log(item.brandNames)
      gio('track', "OW__addToCart", {
        "modelNumber_var" : `${item.productSize}`,
        "productBrand_var" : `${item.brandNames === null ? '-' : item.brandNames}`,
        "productSeries_var" : `-`,
        "isGreenProduct": `-`,
        "goodsPrice_var": Number(item.marketPrice) >= 5000000 ? 0 :
         (item.customerPrice ? item.customerPrice : item.afterDiscountTaxPrice ?
          item.afterDiscountTaxPrice : item.marketPrice),
        "quantity_var": 1,
        "pageName_var": `${getPageName()}`,
        "area_var": `SDI手动添加`,
        "productName_var": `${item.productName === undefined ? '-' : item.productName}`,
      });
    })
    // 调用接口，传递对象数组
    batchProductToCart(parma).then(res => {
      message.success('添加购物车成功');
    });
  };
  const rowSelectionManualAddition = {
    selectedRowKeysManua,
    onChange: (selectedKeysManua, products) => {
      if(selectedKeysManua.length > selectedRowKeysManua.length) {
        const keyAdd = products[selectedKeysManua.length - 1];
        const index = productsData?.list?.findIndex(item => item.id === selectedKeysManua[selectedKeysManua.length - 1]) + 1
        gio('track', "OW_searchResultClick", {
          "searchType_var" : `关键词搜索`,
          "keyWord_var" : `${params.name === undefined ? '-' : params.name}`,
          "partNumber_var": `${params.skuCode === undefined ? '-' : params.skuCode}`,
          "MaterialNumber_var": `${params.ifsSku === undefined ? '-' : params.ifsSku}`,
          "parPageName_var" : `${getPageName()}`,
          "area_var": `SDI快速下单`,
          "trafficPositon_var": `${index}`,
          "productName_var": `${keyAdd.productName}`,
          "orderNumber_var": `${keyAdd.skuCode}`,
        });
      }
      setSelectedRowKeysManua(selectedKeysManua);
    },
  };

  const menuHander: MenuProps['onClick'] = e => {
    // console.log(e, '3333333');

    // setCurrent(e.key, () => {
    //   console.log('Updated current:', e.key, 222222222222);
    // });
  };

  useEffect(() => {
    getIsSDI();
    querySelectionService();
    if (!sessionStorage.getItem('productClass')) {
      queryCategoryList();
    } else {
      const res2 = sessionStorage.getItem('productClass');
      const res1 = JSON.parse(res2);
      const res = res1.res;
      setItems(arr =>
        arr.map((item, index) => {
          return index === 0
            ? {
                ...item,
                children: handlerItems(res),
              }
            : item;
        })
      );
    }
    if (!sessionStorage.getItem('industrialDictionary')) {
      queryIndustrialDictionary();
    } else {
      const res2 = sessionStorage.getItem('industrialDictionary');
      const res1 = JSON.parse(res2);
      const res = res1.res;

      setItems(arr =>
        arr.map((item, index) => {
          return index === 3
            ? {
                ...item,
                children: handlerIndustrialDictionary(res, 'firstId', '111'),
              }
            : item;
        })
      );
    }
    if (!sessionStorage.getItem('ProductInfo')) {
      queryProductInfo();
    } else {
      const res2 = sessionStorage.getItem('ProductInfo');
      const res1 = JSON.parse(res2);
      const res = res1.res;

      setItems(arr =>
        arr.map((item: any, index: number) => {
          return index === 2
            ? {
                ...item,
                children: handlerProductInfo(res),
              }
            : item;
        })
      );
    }
    if (!sessionStorage.getItem('IndustryCases')) {
      queryIndustryCases();
    } else {
      const res2 = sessionStorage.getItem('IndustryCases');
      const res1 = JSON.parse(res2);
      const res = res1.res;

      setItems(arr =>
        arr.map((item: any, index: number) => {
          return index === 4
            ? {
                ...item,
                children: handlerIndustryCases(res),
              }
            : item;
        })
      );
    }
    // queryIndustrialDictionary();
  }, []);
  // 快速下单
  const quickOrdering = () => {
    gio('track', "OW_topNavigationBarClick", {
      "trafficName_var" : `快速下单`,
      "firstpositionName_var" : `-`,
      "secondpositionName_var" : `-`,
      "thirdpositionName_var": `-`,
      "fourPositionName_var": `-`,
      "pageName_var": `${getPageName()}`,
    });
    navigate('/quick-ordering');
    window.location.reload();
  };
  const SDIquickOrdering = () => {
    gio('track', "OW_topNavigationBarClick", {
      "trafficName_var" : `SDI快速下单`,
      "firstpositionName_var" : `-`,
      "secondpositionName_var" : `-`,
      "thirdpositionName_var": `-`,
      "fourPositionName_var": `-`,
      "pageName_var": `${getPageName()}`,
    });
    setIsquickImportModal(true);
  };
  const importDown = () => {
    quickTemplate().then(res => {
      const data = res.data;
      const newBlob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const fileName = '快速下单模板';
      // 构建一个链接元素，并触发下载
      const link = document.createElement('a');
      link.href = URL.createObjectURL(newBlob);
      link.download = fileName;
      link.click();
    });
  };
  const handleClose = () => {
    setManualAdditionSDIModal(false);
    setIsquickImportModal(false);
    navigate('/cart');
    refresh(!current);
  }
  const config1 = {
    onRemove: file => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: file => {
      if (fileList.length === 1) {
        message.warning('只能上传一个');
        return false;
      }
      setFileList([...fileList, file]);
      // handleUpload([...fileList, file]);
      return false;
    },
    fileList,
  };
  const handleUpload = () => {
    const formData = new FormData();
    fileList.forEach(file => {
      formData.append('file', file);
    });
    if (fileList.length === 0) {
      message.error("请上传文件");
      return ;
    }
    setFileList([]);
    setUploading(true);
    gio('track', "OW__addToCart", {
      "modelNumber_var" : `-`,
      "productBrand_var" : `-`,
      "productSeries_var" : `-`,
      "isGreenProduct": `-`,
      "goodsPrice_var": `-`,
      "quantity_var": `-`,
      "pageName_var": `${getPageName()}`,
      "area_var": `SDI批量导入`,
      "productName_var": `-`,
    });
    SDIXlsx(formData)
      .then(res => {
        if (res === '导入成功') {
          gio('track', "OW_quickOrder", {
            "failReason_var" : `-`,
            "isSuccess_var" : `是`,
          });
          message.success('导入成功');
          setIsquickImportModal(false);
          navigate('/cart');
          refresh(!current);
        }
      }).catch(error => {
        console.log(error)
        gio('track', "OW_quickOrder", {
          "failReason_var" : `${error.message}`,
          "isSuccess_var" : `否`,
        });
      })
      .finally(() => {
        setUploading(false);
      });
  };
  const content = (
    <div>
      <Tag
        className="hotTag"
        onClick={() => {
          setSearchRegion('顶部导航栏');
          setSearchType('热门搜索');
          setIsSearch(true);
          gio('track', "OW_topNavigationBarClick", {
            "trafficName_var" : `搜索`,
            "firstpositionName_var" : `-`,
            "secondpositionName_var" : `-`,
            "thirdpositionName_var": `-`,
            "fourPositionName_var": `-`,
            "pageName_var": `${getPageName()}`,
          });
          const paramsData = {
            mallL1Categories: '',
            mallL2Categories: '',
            mallL3Categories: '',
            mallL4Categories: '',
            mallL5Categories: '',
            keyWord: '变频器',
            pageNo: 1,
            pageSize: 20,
            brandIds:[],
            sustainableOfferQualification: '',
            hasStock: null,
            attributes:[],
          }
          navigate(`/productList?data=${JSON.stringify(paramsData)}`);
          // window.location.reload();
          setSearchRegion('顶部导航栏');
          setSearchType('热门搜索');
          setIsSearch(true);
        }}>
        变频器
      </Tag>
      <Tag
        className="hotTag"
        onClick={() => {
          setSearchRegion('顶部导航栏');
          setSearchType('热门搜索');
          setIsSearch(true);
          gio('track', "OW_topNavigationBarClick", {
            "trafficName_var" : `搜索`,
            "firstpositionName_var" : `-`,
            "secondpositionName_var" : `-`,
            "thirdpositionName_var": `-`,
            "fourPositionName_var": `-`,
            "pageName_var": `${getPageName()}`,
          });
          const paramsData = {
            mallL1Categories: '',
            mallL2Categories: '',
            mallL3Categories: '',
            mallL4Categories: '',
            mallL5Categories: '',
            keyWord: '断路器',
            pageNo: 1,
            pageSize: 20,
            brandIds:[],
            sustainableOfferQualification: '',
            hasStock: null,
            attributes:[],
          }
          navigate(`/productList?data=${JSON.stringify(paramsData)}`);
          // window.location.reload();
          setSearchRegion('顶部导航栏');
          setSearchType('热门搜索');
          setIsSearch(true);
        }}>
        断路器
      </Tag>
      <Tag
        className="hotTag"
        onClick={() => {
          setSearchRegion('顶部导航栏');
          setSearchType('热门搜索');
          setIsSearch(true);
          gio('track', "OW_topNavigationBarClick", {
            "trafficName_var" : `搜索`,
            "firstpositionName_var" : `-`,
            "secondpositionName_var" : `-`,
            "thirdpositionName_var": `-`,
            "fourPositionName_var": `-`,
            "pageName_var": `${getPageName()}`,
          });
          const paramsData = {
            mallL1Categories: '',
            mallL2Categories: '',
            mallL3Categories: '',
            mallL4Categories: '',
            mallL5Categories: '',
            keyWord: '接触器',
            pageNo: 1,
            pageSize: 20,
            brandIds:[],
            sustainableOfferQualification: '',
            hasStock: null,
            attributes:[],
          }
          navigate(`/productList?data=${JSON.stringify(paramsData)}`);
          // window.location.reload();
          setSearchRegion('顶部导航栏');
          setSearchType('热门搜索');
          setIsSearch(true);
        }}>
        接触器
      </Tag>
      <Tag
        className="hotTag"
        onClick={() => {
          setSearchRegion('顶部导航栏');
          setSearchType('热门搜索');
          setIsSearch(true);
          gio('track', "OW_topNavigationBarClick", {
            "trafficName_var" : `搜索`,
            "firstpositionName_var" : `-`,
            "secondpositionName_var" : `-`,
            "thirdpositionName_var": `-`,
            "fourPositionName_var": `-`,
            "pageName_var": `${getPageName()}`,
          });
          const paramsData = {
            mallL1Categories: '',
            mallL2Categories: '',
            mallL3Categories: '',
            mallL4Categories: '',
            mallL5Categories: '',
            keyWord: '继电器',
            pageNo: 1,
            pageSize: 20,
            brandIds:[],
            sustainableOfferQualification: '',
            hasStock: null,
            attributes:[],
          }
          navigate(`/productList?data=${JSON.stringify(paramsData)}`);
          // window.location.reload();
          setSearchRegion('顶部导航栏');
          setSearchType('热门搜索');
          setIsSearch(true);
        }}>
        继电器
      </Tag>
      <div style={{maxHeight: '460px', overflow: 'auto'}}>
        {keyWord && keyWord !== '' ? <List
        dataSource={searchList}
        loading={searchLoading}
        renderItem={(item) =>
          <List.Item onClick={() => {
            navigate(`/productDetail?id=${item.id}&skuCode=${item.skuCode}`)
            window.location.reload();
          }}><div style={{cursor: 'pointer'}}>{item?.skuCode}-{item?.brandName}-{item?.name}</div></List.Item>
        }
        ></List> : null}
      </div>
    </div>
  );
  const searchChange = (e) => {
    setSearchLoading(true);
    setKeyWord(e.target.value)
    fetchProductList({ keyWord: e.target.value, pageNo: 1, pageSize: 8 }).then(res => {
      setSearchList(res?.list)
    }).finally(() => setSearchLoading(false));
  }
  return (
    <header className={styles.navigation}>
      <div className={styles.contentBox}>
        <img
          src={logoImg}
          className={styles.logoImg}
          alt=""
          onClick={() => {
            navigate('/home');
            window.location.reload();
          }}
        />
        <div className={styles.menuICariy}>
          <Menu onClick={menuHander} mode="horizontal" selectedKeys={[current]} items={items} />
        </div>

        <Popover
          content={content}
          arrow={false}
          overlayClassName="hotPopver"
          open={isPopover}
          placement="bottom"
          onClick={() => setIsPopover(true)}
          title={
            <>
              <span>热门搜索</span>
              <Button className={styles.HOTImg} type="primary" size="small" corner={true}>
                HOT
              </Button>
              <CloseOutlined style={{ marginLeft: 170 }} onClick={() => setIsPopover(false)} />
            </>
          }
          trigger="click">
          <Input
            className={styles.searchInput}
            value={keyWord}
            placeholder={'请输入搜索关键词'}
            onChange={searchChange}
            onPressEnter={e => {
              const paramsData = {
                mallL1Categories: '',
                mallL2Categories: '',
                mallL3Categories: '',
                mallL4Categories: '',
                mallL5Categories: '',
                keyWord: e.target.value,
                pageNo: 1,
                pageSize: 20,
                brandIds:[],
                sustainableOfferQualification: '',
                hasStock: null,
                attributes:[],
              }
              navigate(`/productList?data=${JSON.stringify(paramsData)}`);
              window.location.reload();
            }}
            variant="borderless"
            suffix={
              <img
                src={search}
                className={styles.searchImg}
                onClick={() => {
                  setSearchRegion('顶部导航栏');
                  setSearchType('关键词搜索');
                  setIsSearch(true);
                  gio('track', "OW_topNavigationBarClick", {
                    "trafficName_var" : `搜索`,
                    "firstpositionName_var" : `-`,
                    "secondpositionName_var" : `-`,
                    "thirdpositionName_var": `-`,
                    "fourPositionName_var": `-`,
                    "pageName_var": `${getPageName()}`,
                  });
                  const paramsData = {
                    mallL1Categories: '',
                    mallL2Categories: '',
                    mallL3Categories: '',
                    mallL4Categories: '',
                    mallL5Categories: '',
                    keyWord: keyWord,
                    pageNo: 1,
                    pageSize: 20,
                    brandIds:[],
                    sustainableOfferQualification: '',
                    hasStock: null,
                    attributes:[],
                  }
                  navigate(`/productList?data=${JSON.stringify(paramsData)}`);
                  // window.location.reload();
                  // fetchProductList({ keyWord, pageNo: 1, pageSize: 999 }).then(res => {
                  //   if (res.code === 200) {
                  //     navigate('/productList');
                  //   }
                  // });
                }}
              />
            }
          />
        </Popover>
        {/* <img
              src={search}
            /> */}
        {/* </div> */}

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src={quickorder} width={20} height={19} />
          {!isSDI ? (
            <div className={`${styles.menuItems} ${styles.mlr15}`} onClick={quickOrdering}>
              快速下单
            </div>
          ) : (
            <div className={`${styles.menuItems} ${styles.mlr15}`} onClick={SDIquickOrdering}>
              SDI快速下单
            </div>
          )}
          <img src={cart} width={23} height={19} />
          <div
            className={`${styles.menuItems} ${styles.mlr15}`}
            onClick={() => {
              gio('track', "OW_topNavigationBarClick", {
                "trafficName_var" : `我的购物车`,
                "firstpositionName_var" : `-`,
                "secondpositionName_var" : `-`,
                "thirdpositionName_var": `-`,
                "fourPositionName_var": `-`,
                "pageName_var": `${getPageName()}`,
              });
              navigate('/cart');
              window.location.reload();
            }}>
            我的购物车
          </div>
        </div>
      </div>

      <Userhook
        current={currentUser}
        onChange={e => {
          handlerParticular(e);
        }}
        onRegister={() => {
          gio('track', "OW_topNavigationBarClick", {
            "trafficName_var" : `注册`,
            "firstpositionName_var" : `-`,
            "secondpositionName_var" : `-`,
            "thirdpositionName_var": `-`,
            "fourPositionName_var": `-`,
            "pageName_var": `${getPageName()}`,
          });
          navigate('/register');
        }}
        onLoginClick={() => {
          gio('track', "OW_topNavigationBarClick", {
            "trafficName_var" : `登录`,
            "firstpositionName_var" : `-`,
            "secondpositionName_var" : `-`,
            "thirdpositionName_var": `-`,
            "fourPositionName_var": `-`,
            "pageName_var": `${getPageName()}`,
          });
          navigate('/loginIn'); // 点击登录跳转到登录页面
        }}
        options={[
          {
            label: '我的订单',
            value: '33',
          },
          {
            label: '账户信息',
            value: '111',
          },
          {
            label: '地址管理',
            value: '22',
          },

          {
            label: '登出',
            value: '66',
          },
        ]}
      />
      <Modal
        title="SDI快速下单"
        open={isquickImportModal}
        // onOk={handleUpload}
        onCancel={() => setIsquickImportModal(false)}
        width={600}
        footer={[
          <Button
            onClick={() => {
              setIsquickImportModal(false);
            }}>
            取消
          </Button>,
          <Button
            onClick={() => {
              setManualAdditionSDIModal(true);
            }}>
            手动添加
          </Button>,
          <Button onClick={handleUpload} type="primary">
            {' '}
            导入
          </Button>,
        ]}
        // okText='导入'
      >
        <div>
          以配置（管理配置）的快速下单导入模板（下载模板）和配置的物料对应关系（管理配置），导入需要采购的物料文件或者手动添加产品到购物车采购。
        </div>
        <div className={styles.uploadcontent}>
          <div>物料文件：</div>
          <Upload {...config1}>
            <Button loading={uploading} icon={<UploadOutlined />} type="primary">
              上传文件
            </Button>
          </Upload>
          <Button className={styles.color_button} type="text" onClick={importDown}>
            快速下单模板.xlsx
          </Button>
        </div>
      </Modal>
      {manualAdditionSDIModal && <Modal
        title="SDI快速下单"
        open={manualAdditionSDIModal}
        width={1200}
        // onCancel={() => setManualAdditionSDIModal(false)}
        onCancel={sdiOnCancel}
        footer={[
          <Button
            onClick={() => {
              setManualAdditionSDIModal(false);
            }}>
            批量导入
          </Button>,
          // <Button onClick={addProductCart}>完成</Button>,
          <Button onClick={handleClose}>关闭</Button>
        ]}>
        <div>
          <div className={styles.searchWrap}>
            <Form form={form}>
              <Row gutter={16}>
                <Col span={5}>
                  <Form.Item name="ifsSku" label="物料号">
                    <Input allowClear placeholder="请输入物料号" />
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item name="skuCode" label="零件号">
                    <Input allowClear placeholder="请输入零件号" />
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item name="name" label="关键字">
                    <Input allowClear placeholder="请输入关键字" />
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item valuePropName="checked"  initialValue={false} name="searchCustomerPrice" label="">
                    <Checkbox
                      onChange={e => {
                        form.setFieldValue('searchCustomerPrice', e.target.checked);
                      }}>
                      仅客户价格单内商品
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Button
                  type="primary"
                  style={{ marginRight: '10px', width: '30px' }}
                  htmlType="submit"
                  onClick={onSearch}>
                  搜索
                </Button>
                <Button onClick={addToCart}>添加</Button>
              </Row>
            </Form>
          </div>
          <Table
            dataSource={productsData?.list}
            rowSelection={rowSelectionManualAddition}
            loading={loading}
            rowKey="id"
            // pagination={{
            //   total: +productsData.total,
            //   current: productsData.pageNum,
            //   pageSize: productsData.pageSize,
            // }}
            pagination={{
              total: Number(productsData?.total),
              current: productsData.pageNum,
              pageSize: productsData.pageSize,
              onChange: (page: number, pageSize) => {
                setParams((obj) => {
                  return {
                    ...obj,
                    pageSize: pageSize,
                    pageNum: page,
                  };
                });
              },
            }}
            columns={columnsList}></Table>
        </div>
      </Modal>}
    </header>
  );
};

export default Navigation;
